// src/components/evaluation/EvaluationChoix.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  TECHNOLOGY_API_ROUTE,
  NIVEAU_API_ROUTE,
  EXERCICE_API_ROUTE
} from "../../routes/api/api_routes";

const EvaluationChoix = () => {
  const navigate = useNavigate();
  const [technologies, setTechnologies] = useState([]);
  const [niveaux, setNiveaux] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const token = localStorage.getItem("access");

  useEffect(() => {
    const fetchAll = async () => {
      try {
        const [techRes, niveauRes] = await Promise.all([
          fetch(TECHNOLOGY_API_ROUTE, {
            headers: { Authorization: `Bearer ${token}` },
          }),
          fetch(NIVEAU_API_ROUTE, {
            headers: { Authorization: `Bearer ${token}` },
          }),
        ]);

        const techData = await techRes.json();
        const nivData = await niveauRes.json();

        setTechnologies(techData.data || []);
        setNiveaux(nivData.data || []);
      } catch (error) {
        console.error("Erreur de chargement des données", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchAll();
  }, [token]);


  const handleStart = async (tech) => {
    console.log("TECH SELECTED:", tech);
    console.log("REDIRECTION VERS: ", `/evaluation/${tech.slug}`);
    try {
      // Tenter de récupérer les exercices groupés par niveau
      const niveauWithExercices = [];

      for (const niveau of niveaux) {
        const res = await fetch(
          `${EXERCICE_API_ROUTE}?technology=${tech.id}&niveau=${niveau.id}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const data = await res.json();
        if ((data.data || []).length > 0) {
          niveauWithExercices.push({
            niveau,
            exercices: data.data,
          });
        }
      }

      if (niveauWithExercices.length === 0) {
        alert(`Aucun exercice disponible pour ${tech.name}`);
        return;
      }

      // Tirer aléatoirement un niveau
      const randomIndex = Math.floor(Math.random() * niveauWithExercices.length);
      const niveauParDefaut = niveauWithExercices[randomIndex].niveau;

      const slug = tech.slug || tech.name?.toLowerCase().replace(/\s+/g, "-");

      navigate(`/evaluation/${slug}`, {
        state: {
          techId: tech.id,
          techName: tech.name,
          niveau: niveauParDefaut,
        },
      });
    } catch (error) {
      console.error("Erreur lors du traitement du démarrage de l'évaluation", error);
    }
  };

  if (isLoading) {
    return (
      <div className="text-center mt-10 text-gray-500">Chargement…</div>
    );
  }

  return (
    <div className="w-full max-w-5xl px-6 mt-10 mx-auto">
      <h1 className="text-3xl font-bold text-center mb-10">
        Choisissez votre langage de programmation
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {technologies.map((tech) => (
          <div
            key={tech.id}
            className="border rounded-xl p-6 shadow-md bg-white"
          >
            <h2 className="text-xl font-bold mb-3">{tech.name}</h2>
            <p className="mb-3 font-semibold">Ce que vous allez pratiquer :</p>
            <ul className="list-disc pl-5 text-gray-600 mb-4">
              <li>Syntaxe de base</li>
              <li>Structures de données</li>
              <li>Fonctions et classes</li>
              <li>Gestion des erreurs</li>
              <li>Manipulation de fichiers</li>
            </ul>
            <button
              onClick={() => handleStart(tech)}
              className="px-6 py-2 border rounded-full hover:bg-gray-100"
            >
              Débuter
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EvaluationChoix;
